var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.file)?_c('div',{staticClass:"video-player"},[_c('video',{staticClass:"video-player-video",attrs:{"width":"100%","playsinline":"","autoplay":_vm.isAutoplay,"id":`video-${_vm.id}`,"controls":"","poster":_vm.poster}},[_c('source',{attrs:{"src":`${encodeURI(_vm.file.src)}`}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }